"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PassengerSelectionStepperUtils = {
  updateRoomOccupancy: function updateRoomOccupancy(roomOccupancy, min, defaultRoomOccupancy) {
    var updatedRoomOccupancy = [];
    if (roomOccupancy == null || roomOccupancy === '' || roomOccupancy.length === 0) {
      for (var i = 0; i < min; i += 1) {
        updatedRoomOccupancy[i] = defaultRoomOccupancy;
      }
      return updatedRoomOccupancy;
    }
    return roomOccupancy;
  },
  getTotalGuests: function getTotalGuests(paxCount) {
    var totalGuests = 0;
    for (var i = 0; i < paxCount.length; i += 1) {
      var room = paxCount[i];
      totalGuests += Object.values(room).reduce(function (a, b) {
        return a + b;
      });
    }
    return totalGuests;
  },
  getTotalGuestsByRoom: function getTotalGuestsByRoom(room, paxCount) {
    var totalGuests = 0;
    if (paxCount.length) {
      var roomInfo = paxCount[room];
      totalGuests += Object.values(roomInfo).reduce(function (a, b) {
        return a + b;
      });
    }
    return totalGuests;
  }
};
var _default = PassengerSelectionStepperUtils;
exports.default = _default;